import React, { useState } from "react";
import { Image, Text, TouchableOpacity, View } from "react-native";
import { connect } from "react-redux";
import { removeFavItem, setFavItems } from "../../actions/fav";
import { fetchApi } from "../../api";
import { STYLES } from "../../assets/styles";
import Container from "../../components/Container";
import CustomButton from "../../components/CustomButton";
import Header from "../../components/Header";
import ListItems from "../../components/ListItems";

function Favourites({ navigation, favItems = [], removeFavItem, setFavItems }) {
  const [refreshing, setRefreshing] = useState(false);

  const handleRemoveItem = (id, itemId) => {
    fetchApi({
      path: `/favitems/${id}`,
      method: "DELETE",
    }).then((res) => {
      if (!res.error) {
        removeFavItem({ item_id: itemId, _id: id });
      }
    });
  };

  const handleNavigation = (id) => {
    navigation.navigate("tabs", {
      screen: "home",
      params: { screen: "item", params: { id: id } },
    });
  };

  const Item = ({
    image_url,
    title,
    index,
    discount,
    price,
    item_id,
    mrp,
    _id,
  }) => (
    <View
      style={{
        flexDirection: "row",
        alignItems: "center",
        ...STYLES.shadow,
        margin: 5,
      }}
    >
      <Image
        source={{ uri: image_url }}
        style={{ width: 70, height: 70, margin: 10 }}
        resizeMode="contain"
      />
      <View style={{ flex: 1, height: "100%", padding: 10 }}>
        <TouchableOpacity onPress={() => handleNavigation(item_id)}>
          <Text style={{ fontSize: STYLES.fontSizes.mini, fontWeight: "bold" }}>
            {title}
          </Text>
          <View style={{ flexDirection: "row", alignItems: "baseline" }}>
            {discount ? (
              <>
                <Text
                  style={{
                    fontSize: STYLES.fontSizes.mini,
                    fontWeight: "bold",
                    color: STYLES.colors.purpel,
                  }}
                >
                  {discount} %
                </Text>
                <Text
                  style={{
                    textDecorationLine: "line-through",
                    fontSize: STYLES.fontSizes.mini,
                    marginHorizontal: 5,
                    color: STYLES.colors.lightFontColor,
                  }}
                >
                  {mrp}
                </Text>
              </>
            ) : null}
            <Text
              style={{
                fontSize: STYLES.fontSizes.small,
                fontWeight: "bold",
              }}
            >
              {price}
            </Text>
          </View>
        </TouchableOpacity>
      </View>
      <CustomButton
        text="Remove"
        textStyle={{ color: STYLES.colors.tomato }}
        transparent
        btnStyle={{ margin: 10 }}
        onPress={() => handleRemoveItem(_id, item_id, index)}
      />
    </View>
  );

  const onRefresh = () => {
    setRefreshing(true);
    fetchApi({
      path: "/favitems",
    }).then((res) => {
      if (res.results) {
        setFavItems(res.results);
      }
      setRefreshing(false);
    });
  };

  return (
    <Container secure>
      <Header backButton title="Favourite Items" navigation={navigation} />
      <ListItems
        empty={{
          iconType: "AntDesign",
          iconName: "heart",
          text: "No Favourite items added",
        }}
        refresh={true}
        refreshing={refreshing}
        onRefresh={onRefresh}
        data={favItems}
        renderItem={(item, index) => (
          <Item key={index} {...item} index={index} />
        )}
      />
    </Container>
  );
}

const mapStateToProps = (state) => ({
  favItems: state.fav.items,
});

const mapDispatchToProps = (dispatch) => ({
  removeFavItem: (data) => dispatch(removeFavItem(data)),
  setFavItems: (data) => dispatch(setFavItems(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Favourites);
